// NOTE @chris should always match the one on the backend: soraban-api/app/models/permission.rb
export enum PermissionsMapEnum {
  // Company permissions (900-999)
  'company.add' = 900,
  'company.edit' = 901,
  'company.delete' = 902,
  'company.view' = 903,
  'company.edit_assignee' = 904,

  // Conversation permissions (200-299)
  'conversation.add' = 200,
  'conversation.edit' = 201,
  'conversation.delete' = 202,
  'conversation.view' = 203,
  'conversation.send_mass_email' = 204,

  // Document permissions (300-399)
  'document.add' = 300,
  'document.edit' = 301,
  'document.delete' = 302,
  'document.view' = 303,
  'document.edit_tags' = 304,
  'document.edit_rename' = 305,
  'document.move' = 306,
  'document.copy' = 307,

  // Firm permissions (800-899)
  'firm.settings' = 800,
  'firm.billing' = 801,
  'firm.client_import' = 802,
  'firm.edit_firm_roles' = 803,

  // Questionnaire permissions (400-499)
  'questionnaire.add' = 400,
  'questionnaire.edit' = 401,
  'questionnaire.delete' = 402,
  'questionnaire.view' = 403,

  // Questionnaire template permissions (500-599)
  'questionnaire_template.add' = 500,
  'questionnaire_template.edit' = 501,
  'questionnaire_template.delete' = 502,
  'questionnaire_template.view' = 503,
  'questionnaire_template.edit_template_editor_messages' = 504,

  // Review and export permissions (700-799)
  'review_and_export.add' = 700,
  'review_and_export.edit' = 701,
  'review_and_export.delete' = 702,
  'review_and_export.view' = 703,

  // Tax return delivery permissions (600-699)
  'tax_return_delivery.add' = 600,
  'tax_return_delivery.edit' = 601,
  'tax_return_delivery.delete' = 602,
  'tax_return_delivery.view' = 603,
  'tax_return_delivery.mark_paid' = 604,
  'tax_return_delivery.send' = 605,

  // User permissions (100-199)
  'user.add' = 100,
  'user.edit' = 101,
  'user.delete' = 102,
  'user.view' = 103,
  'user.edit_assignee' = 104,
}
